<template>
  <div>
    <b-button
      v-b-toggle.sidebar-dashboard-brand
      size="sm"
      variant="outline-dark"
      pill
      style="position: absolute; top: 3.5rem;"
    >
      {{ selectedBrand }}
    </b-button>
    <b-sidebar
      class="pbi-sidebar"
      id="sidebar-dashboard-brand"
      title="Dashboard"
      bg-variant="dark"
      text-variant="light"
      shadow
      no-title
      backdrop
    >
      <div class="px-3 py-2 text-dark">
        <treeselect
          v-model="selectedBrand"
          :options="brandMenu"
          :clearable="false"
        />
      </div>
    </b-sidebar>

    <report-f1 v-if="brand === 'F1'" :token="token" :embed-url="embedUrl" />
    <report-t1 v-else-if="brand === 'T1'" :token="token" :embed-url="embedUrl" />
    <report-r1 v-else-if="brand === 'R1'" :token="token" :embed-url="embedUrl" />
    <report-p1
        v-else-if="brand === 'P1'"
      :token="token"
      :embed-url="embedUrl"
    />
    <report-j1 v-else-if="brand === 'J1'" :token="token" :embed-url="embedUrl" />
    <div v-else>
      <h2 class="align-middle text-center" style="margin: 30vh 0 0 0;" >Not Available.</h2>
    </div>
  </div>
</template>

<script>
/*global _*/
import application from '@/mixins/application';
import reportF1 from '@/components/dashboard/ReportF1';
import reportT1 from '@/components/dashboard/ReportT1';
import reportR1 from '@/components/dashboard/ReportR1';
import reportP1 from '@/components/dashboard/ReportP1';
import reportJ1 from '@/components/dashboard/ReportJ1';

export default {
  name: 'BrandPerformance',
  components: { reportF1, reportT1, reportR1, reportP1, reportJ1 },
  mixins: [application],
  mounted() {
    const vm = this;
    const user = vm.$store.state.user;

    vm.axios.get('/api/dashboard/EmbedUrls').then(function(resp) {
      if (resp.data) {
        vm.embedUrlMappings = resp.data;
        const embedUrlMapping = _.find(vm.embedUrlMappings, {
          powerBiEmbedUrlId: vm.$route.params.id
        });
        vm.embedUrl = embedUrlMapping ? embedUrlMapping.embedUrl : '';
        vm.selectedBrand = user.brandPermission[0];
        vm.ChangeBrand();
      }
    });
  },
  data() {
    const user = this.$store.state.user;
    let menu = _.map(user.brandPermission, function(brand) {
      return {
        id: brand,
        label: brand
      };
    });

    return {
      brandMenu: menu,
      brand: '',
      selectedBrand: '',
      embedUrl: '',
      embedUrlMappings: [],
      token: '',
      report: null
    };
  },
  watch: {
    $route() {
      const vm = this;
      const embedUrlMapping = _.find(this.embedUrlMappings, {
        powerBiEmbedUrlId: this.$route.params.id
      });
      vm.embedUrl = embedUrlMapping ? embedUrlMapping.embedUrl : '';
      //vm.LoadReport();
    },
    selectedBrand() {
      this.ChangeBrand();
    }
  },
  methods: {
    ChangeBrand: function() {
      const vm = this;
      let code = 0;
      switch (vm.selectedBrand) {
        case 'F1':
          code = 1;
          break;
        case 'T1':
          code = 2;
          break;
        case 'R1':
          code = 3;
          break;
        case 'P1':
          code = 4;
          break;
        case 'J1':
          code = 5;
          break;
      }
      vm.axios
        .get('/api/dashboard/AccessToken', { params: { account: code } })
        .then(function(resp) {
          if (resp.data) {
            vm.token = resp.data;
            vm.brand = vm.selectedBrand;
          }
        });
    },
    // eslint-disable-line no-unused-vars
    OnItemClick(e, item) {
      // eslint-disable-line no-unused-vars
      this.ChangeBrand(item.title);
    }
  }
};
</script>

<style lang="scss">
.pbiReportContainer {
  width: 100%;
  height: calc(100vh - 66px);
  padding: 5px;
}

.pbiReportContainer iframe {
  border: none !important;
}

.sidebar-brand {
  height: calc(100vh - 56px) !important;
  top: auto !important;
  width: 150px !important;
  text-align: left !important;
}

.sidebar-brand .vsm--link {
  padding: 5px 10px !important;
}
</style>
